export const discountPanelTestIds = {
  panel: 'discount-panel',
};
